import { render, staticRenderFns } from "./PurchaseReport.vue?vue&type=template&id=4e82a72a&scoped=true"
import script from "./PurchaseReport.vue?vue&type=script&lang=js"
export * from "./PurchaseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e82a72a",
  null
  
)

export default component.exports